import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Login.vue";
import HXLogin from "../views/HXLogin.vue";
import NoPage from "../views/404";
import Layout from "../views/Layout/Layout";
import Report from '../views/Fitness/nutritionReport/upload_report'
import semesterTopic from '../views/evaluate/semesterTopic'
import addProcessEvaluate from '../views/evaluate/addProcessEvaluate'
import editProcessEvaluate from '../views/evaluate/editProcessEvaluate'
import all_result from '../views/evaluate/all_result'
import reportPatriarchBoby from '../views/evaluate/reportPatriarchBoby'
import SubjectEvaluationEdit from '../views/SubjectEvaluation/edit'
import SubjectEvaluationTeacher from '../views/SubjectEvaluation/teacher'
import SubjectResultSetQuestion from '../views/SubjectResult/setQuestion'
import SubjectResultChildResult from '../views/SubjectResult/childResult'
import SubjectResultClassResult from '../views/SubjectResult/classResult'
import reportSemester from '../views/evaluate/reportSemester'
import reportSemesterBaby from '../views/evaluate/reportSemesterBaby'
import reportPatriarch from '../views/evaluate/reportPatriarch'
import ProceQuestionEdit from '../views/evaluate/ProceQuestionEdit'

import templateConfiguration from "../views/growingFootprint/templateConfiguration.vue"
import templateStatic from "../views/growingFootprint/static.vue"
import configuration from "../views/growingFootprint/configuration.vue"
import record from "../views/growingFootprint/record.vue"
import growingFootprintReport from "../views/growingFootprint/report.vue"
import indexHome from '../views/Home.vue'


Vue.use(Router);
const createRouter = () =>
  new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
        path: "/404",
        component: NoPage,
        name: "404",
        meta: {
          title: "404",
          requireAuth: true,
        },
        hidden: true,
      },
      {
        path: '/SubjectResultChildResult',
        name: "SubjectResultChildResult",
        component: SubjectResultChildResult,
        meta: {
          title: "",
          NoTabPage: true,
          NoNeedHome: true, // 添加该字段，表示不需要home模板
        },
      },
      {
        path: '/growingFootprintReport',
        name: "growingFootprintReport",
        component: growingFootprintReport,
        meta: {
          title: "",
          NoTabPage: true,
          NoNeedHome: true, // 添加该字段，表示不需要home模板
        },
      },
      {
        path: '/SubjectResultClassResult',
        name: "SubjectResultClassResult",
        component: SubjectResultClassResult,
        meta: {
          title: "",
          NoTabPage: true,
          NoNeedHome: true, // 添加该字段，表示不需要home模板
        },
      },
      {
        path: "/login",
        component: Login,
        name: "login",
        iconCls: "fa-address-card", //图标样式class
        meta: {
          title: "登录",
          NoTabPage: true,
          NoNeedHome: true, // 添加该字段，表示不需要home模板
        },
        hidden: true,
      },
      {
        path: "/hxlogin",
        component: HXLogin,
        name: "hxlogin",
        iconCls: "fa-address-card", //图标样式class
        meta: {
          title: "登录",
          NoTabPage: true,
          NoNeedHome: true, // 添加该字段，表示不需要home模板
        },
        hidden: true,
      },

      {
        path: "/",
        component: Layout,
        name: "Layout",
        redirect: '/indexHome',
        iconCls: "fa-address-card", //图标样式class
        children: [{
            path: "/indexHome",
            component: indexHome,
            name: "概况",
            meta: {
              title: "概况",
              requireAuth: true,
            },
            hidden: true,
          }, {
            path: 'semesterTopic',
            component: semesterTopic,
            meta: {
              title: "评价",
              NoTabPage: false,
              NoNeedHome: false, // 添加该字段，表示不需要home模板
            },
          },

          {
            path: 'ProceQuestionEdit',
            component: ProceQuestionEdit,
            meta: {
              title: "",
              NoTabPage: false,
              NoNeedHome: false, // 添加该字段，表示不需要home模板
            },
          },
          {
            path: 'templateConfiguration',
            component: templateConfiguration,
            meta: {
              title: "",
              NoTabPage: false,
              NoNeedHome: false, // 添加该字段，表示不需要home模板
            },
          },
          {
            path: 'templateStatic',
            component: templateStatic,
            meta: {
              title: "",
              NoTabPage: false,
              NoNeedHome: false, // 添加该字段，表示不需要home模板
            },
          },
          {
            path: 'configuration',
            component: configuration,
            meta: {
              title: "",
              NoTabPage: false,
              NoNeedHome: false, // 添加该字段，表示不需要home模板
            },
          },

          {
            path: 'record',
            component: record,
            meta: {
              title: "",
              NoTabPage: false,
              NoNeedHome: false, // 添加该字段，表示不需要home模板
            },
          },
          {
            path: 'SubjectEvaluationEdit',
            component: SubjectEvaluationEdit,
            meta: {
              title: "",
              NoTabPage: false,
              NoNeedHome: false, // 添加该字段，表示不需要home模板
            },
          },
          {
            path: 'SubjectEvaluationTeacher',
            component: SubjectEvaluationTeacher,
            meta: {
              title: "",
              NoTabPage: false,
              NoNeedHome: false, // 添加该字段，表示不需要home模板
            },
          },

          {
            path: 'SubjectResultSetQuestion',
            component: SubjectResultSetQuestion,
            meta: {
              title: "",
              NoTabPage: false,
              NoNeedHome: false, // 添加该字段，表示不需要home模板
            },
          },
          {
            path: 'addProcessEvaluate',
            component: addProcessEvaluate,
            meta: {
              title: "评价",
              NoTabPage: false,
              NoNeedHome: false, // 添加该字段，表示不需要home模板
            },
          },
          {
            path: 'editProcessEvaluate',
            component: editProcessEvaluate,
            meta: {
              title: "评价",
              NoTabPage: false,
              NoNeedHome: false, // 添加该字段，表示不需要home模板
            },
          }
        ],
        hidden: true,
      }, {
        path: "/Report",
        component: Report,
        name: "Report",
        iconCls: "fa-address-card", //图标样式class
        meta: {
          title: "蘑菇岛下载报告",
          NoTabPage: true,
          NoNeedHome: true, // 添加该字段，表示不需要home模板
        },
        hidden: true,
      },
      {
        path: "/reportPatriarchBoby",
        component: reportPatriarchBoby,
        name: "reportPatriarchBoby",
        iconCls: "fa-address-card", //图标样式class
        meta: {
          title: "过程报告",
          NoTabPage: true,
          NoNeedHome: true, // 添加该字段，表示不需要home模板
        },
        hidden: true,
      },
      {
        path: "/all_result",
        component: all_result,
        name: "all_result",
        iconCls: "fa-address-card", //图标样式class
        meta: {
          title: "过程报告",
          NoTabPage: true,
          NoNeedHome: true, // 添加该字段，表示不需要home模板
        },
        hidden: true,
      }, {
        path: "/reportSemester",
        component: reportSemester,
        name: "学期报告",
        iconCls: "fa-address-card", //图标样式class
        meta: {
          title: "蘑菇岛下载报告",
          NoTabPage: true,
          NoNeedHome: true, // 添加该字段，表示不需要home模板
        },
        hidden: true,
      }, {
        path: "/reportSemesterBaby",
        component: reportSemesterBaby,
        name: "学期报告",
        iconCls: "fa-address-card", //图标样式class
        meta: {
          title: "蘑菇岛下载报告",
          NoTabPage: true,
          NoNeedHome: true, // 添加该字段，表示不需要home模板
        },
        hidden: true,
      },
      {
        path: "/reportPatriarch",
        component: reportPatriarch,
        name: "家长报告",
        iconCls: "fa-address-card", //图标样式class
        meta: {
          title: "蘑菇岛下载报告",
          NoTabPage: true,
          NoNeedHome: true, // 添加该字段，表示不需要home模板
        },
        hidden: true,
      },

      {
        path: "*",
        hidden: true,
        redirect: {
          path: "/404"
        },
      },
    ],
  });

const router = createRouter();

export function filterAsyncRouter(asyncRouterMap) {
  //注意这里的 asyncRouterMap 是一个数组
  const accessedRouters = asyncRouterMap.filter((route) => {
    if (route.path && !route.IsButton) {
      if (route.path === "/" || route.path === "-") {
        //Layout组件特殊处理
        route.component = Layout;
      } else {
        try {
          let file = route.path.replace("/:id")
          route.component = () => import('@/views' + file + '.vue');
        } catch (e) {

          try {
            route.component = () => {
              import("@/views" + route.path.replace("/:id", "") + ".vue");
            }
          } catch (error) {
            console.error(error)
            console.info(
              "%c 当前路由 " +
              route.path.replace("/:id", "") +
              ".vue 不存在，因此如法导入组件，请检查接口数据和组件是否匹配，并重新登录，清空缓存!",
              "color:red"
            );
          }
        }
      }
    }
    if (route.children && route.children.length && !route.IsButton) {
      route.children = filterAsyncRouter(route.children);
    }
    return true;
  });

  return accessedRouters;
}

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // the relevant part
}

router.$addRoutes = (params) => {
  var f = (item) => {
    if (item["children"]) {
      item["children"] = item["children"].filter(f);
      return true;
    } else if (item["IsButton"]) {
      return item["IsButton"] === false;
    } else {
      return true;
    }
  };
  var params = params.filter(f);

  router.addRoutes(params);
};

export default router;